import { Box, Stepper, Step, StepLabel, useTheme, SxProps } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

interface WizardProgressProps {
  steps: Array<{ id: string; title: string }>;
  currentStep: number;
  sx?: SxProps;
}

const WizardProgress: React.FC<WizardProgressProps> = ({ steps, currentStep, sx }) => {
  const theme = useTheme();

  return (
    <Box sx={sx}>
      <Stepper 
        activeStep={currentStep} 
        alternativeLabel
        sx={{
          '& .MuiStepConnector-line': {
            borderColor: theme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.1)' 
              : 'rgba(0, 0, 0, 0.1)',
            borderTopWidth: 2,
          },
          '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
            borderTopWidth: 2,
          },
          '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
            borderTopWidth: 2,
          },
        }}
      >
        {steps.map((step, index) => (
          <Step key={step.id}>
            <StepLabel
              StepIconProps={{
                sx: {
                  color: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.3)'
                    : 'rgba(0, 0, 0, 0.3)',
                  '&.Mui-active': {
                    color: theme.palette.primary.main,
                  },
                  '&.Mui-completed': {
                    color: theme.palette.primary.main,
                  },
                  fontSize: 28,
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  ...(index < currentStep && {
                    '& .MuiStepIcon-text': {
                      display: 'none',
                    },
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%',
                      // Use the Check icon
                    },
                  }),
                },
              }}
              sx={{
                '& .MuiStepLabel-label': {
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: theme.palette.text.secondary,
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  opacity: 0.7,
                  '&.Mui-active': {
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                    opacity: 1,
                  },
                  '&.Mui-completed': {
                    color: theme.palette.text.primary,
                    opacity: 0.9,
                  },
                },
              }}
            >
              {step.title}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default WizardProgress;